
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investors/company-announcements",
      function () {
        return require("private-next-pages/investors/company-announcements.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/investors/company-announcements"])
      });
    }
  